import axios from 'axios';
//import * as RootNavigation from '../utils/RootNavigation'; // This will depend on your routing setup
import Auth from '../utils/Auth';

const REACT_APP_DEPARTMENT_API_URL = process.env.REACT_APP_DEPARTMENT_API_URL;
const departmentApiBaseUrs = `${REACT_APP_DEPARTMENT_API_URL}`;


const DepartmentService = axios.create({
    baseURL: departmentApiBaseUrs,
    //timeout: 1000000,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
    },
});

// Request interceptor to add the authorization token
DepartmentService.interceptors.request.use(async (config) => {
    const authToken = await Auth.getAuthToken();
    if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
    }
    config.headers['X-Current-Path'] = window.location.href;
    return config;
});

// // Response interceptor for handling responses and errors
// Service.interceptors.response.use(
//     (response) => {
//         if (response.status === 200 || response.status === 201) {
//             return response;
//         } else {
//             return Promise.reject(response);
//         }
//     },
//     async (error) => {
//         if (error?.response?.status === 401) {
//             await Auth.clearAuthToken();
//             RootNavigation.resetRoot(0, 'SignIn'); // Adjust based on your routing
//             return Promise.reject(error.response);
//         } else {
//             return Promise.reject(error.response);
//         }
//     },
// );

// const AdminService = axios.create({
//     baseURL: getBaseURL('admin'),
//     timeout: 10000,
//     headers: {
//         'Content-Type': 'application/json;charset=UTF-8',
//     },
// });

//export { Service, AdminService };

export default DepartmentService;
